<div class="">
  <fx-bonus-treeview
    [items]="data"
    [root]="true"
    (expanded)="onExpanded($event)"
    (moded)="onModed($event)"
    (slct)="onSelectItem($event)"
  ></fx-bonus-treeview>
</div>
